module.exports = new __parcel__URL__("shop_machines_bp_blob_cosmetic.17d1a75d.png").toString();